"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import { Fragment } from "react";
import { useAuthorHover } from "@/components/ArticleContent/components/Byline/context/byline-context";
import { EmailLink } from "@/components/Link/EmailLink/EmailLink.component";
import type { ArticleContentModel } from "@/services/api/content/models/article-content-model.types";
import { startCase } from "@/utilities/string/start-case";
type FeatureAuthorListProps = {
  readonly authors: ReadonlyArray<ArticleContentModel.Author>;
};
export function FeatureAuthorList(t0) {
  const $ = _c(11);
  const {
    authors
  } = t0;
  const {
    handleMouseEnter,
    handleMouseLeave,
    hoveredAuthorIndex
  } = useAuthorHover();
  let t1;
  if ($[0] !== authors || $[1] !== handleMouseEnter || $[2] !== handleMouseLeave || $[3] !== hoveredAuthorIndex) {
    let t2;
    if ($[5] !== handleMouseEnter || $[6] !== handleMouseLeave || $[7] !== hoveredAuthorIndex) {
      t2 = (t3, index) => {
        const {
          email,
          fullName
        } = t3;
        return <Fragment key={email || fullName}>{index > 0 ? <span>, </span> : null}{email !== null ? <EmailLink className={clsx("transition-all duration-150 hover:no-underline", hoveredAuthorIndex === index ? "no-underline" : "underline")} emailAddress={email} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={handleMouseLeave} position={`feature-byline-${index}`}><span>{startCase(fullName)}</span></EmailLink> : <span>{startCase(fullName)}</span>}</Fragment>;
      };
      $[5] = handleMouseEnter;
      $[6] = handleMouseLeave;
      $[7] = hoveredAuthorIndex;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = authors.map(t2);
    $[0] = authors;
    $[1] = handleMouseEnter;
    $[2] = handleMouseLeave;
    $[3] = hoveredAuthorIndex;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <div className="font-theme-bold text-sm leading-tight">{t1}</div>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}